import { render } from "./F2Chart.vue?vue&type=template&id=1d8b3bab&scoped=true&ts=true"
import script from "./F2Chart.vue?vue&type=script&lang=ts"
export * from "./F2Chart.vue?vue&type=script&lang=ts"

import "./F2Chart.vue?vue&type=style&index=0&id=1d8b3bab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8b3bab"]])

export default __exports__